import React from 'react'
import { Registry } from '@react-registry'
//@ts-ignore
import styles from '../styles.module.css'

function GridRow({ children, attributes }) {
  return (
    <div {...attributes} data-testid='row' className={styles['scrte-grid-row']}>
      {children}
    </div>
  )
}

const ComponentMeta = {
  Component: GridRow,
  dndOptions: {
    DisableDND: true,
    DisableSelectionHalo: true,
  },
}

const registryCondition = {
  id: 'row',
  registry: 'v2.element',
}

Registry.register(ComponentMeta, registryCondition)

export default GridRow
